import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, MapPin } from "lucide-react";
import { LOGO_URL, TOURNAMENT, SOCIAL } from "../lib/constants";
import { useT } from "../lib/i18n";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Footer() {
    const { t } = useT();
    return (
        <footer className="border-t border-white/10 mt-24 bg-black/80" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
                <div>
                    <div className="flex items-center gap-3 mb-4">
                        <img src={LOGO_URL} alt="logo" className="h-14 w-14 object-contain" />
                        <div>
                            <div className="font-display text-2xl tracking-wider">{TOURNAMENT.name}</div>
                            <div className="text-[10px] tracking-[0.3em] text-[#4FE0D5] uppercase">{t("tournament.edition")}</div>
                        </div>
                    </div>
                    <p className="text-sm text-white/60 leading-relaxed">
                        {t("tournament.tagline")}
                    </p>
                    <div className="mt-5">
                        <div className="label-mini mb-2">{t("footer.lang")}</div>
                        <LanguageSwitcher variant="footer" />
                    </div>
                </div>
                <div>
                    <div className="label-mini mb-3">{t("footer.navigation")}</div>
                    <ul className="grid gap-2 text-sm">
                        <li><Link to="/horaire" className="hover:text-[#7FD93C]">{t("nav.schedule")}</Link></li>
                        <li><Link to="/equipes" className="hover:text-[#7FD93C]">{t("nav.teams")}</Link></li>
                        <li><Link to="/classement" className="hover:text-[#7FD93C]">{t("nav.standings")}</Link></li>
                        <li><Link to="/nouvelles" className="hover:text-[#7FD93C]">{t("nav.news")}</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="label-mini mb-3">{t("footer.tournament")}</div>
                    <ul className="grid gap-2 text-sm text-white/70">
                        <li>{t("tournament.date")}</li>
                        <li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5 text-[#4FE0D5]" />{t("tournament.arena")}</li>
                        <li className="text-white/50 text-xs">{TOURNAMENT.address}</li>
                    </ul>
                </div>
                <div>
                    <div className="label-mini mb-3">{t("footer.follow")}</div>
                    <div className="flex gap-3">
                        <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" data-testid="link-facebook" className="p-2 border border-white/10 hover:border-[#7FD93C] hover:text-[#7FD93C] transition-colors"><Facebook size={18} /></a>
                        <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" data-testid="link-instagram" className="p-2 border border-white/10 hover:border-[#7FD93C] hover:text-[#7FD93C] transition-colors"><Instagram size={18} /></a>
                        <Link to="/contact" data-testid="link-contact-footer" className="p-2 border border-white/10 hover:border-[#7FD93C] hover:text-[#7FD93C] transition-colors"><Mail size={18} /></Link>
                    </div>
                </div>
            </div>
            <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
                <div>© {new Date().getFullYear()} {TOURNAMENT.name} — {t("footer.rights")}</div>
                <div className="mt-2" data-testid="credit-samourai">
                    {t("footer.crafted_with")} <span className="text-rose-500" aria-label={t("footer.love")}>❤</span> {t("footer.by")}
                    {" "}
                    <a
                        href="https://lesamouraiduweb.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#7FD93C] hover:text-[#4FE0D5] transition-colors font-semibold"
                        data-testid="link-samourai-du-web"
                    >
                        {t("footer.samourai")}
                    </a>
                    {" "}!
                </div>
            </div>
        </footer>
    );
}
